import { useStores } from 'hooks/useStores';
import classNames from 'classnames';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import React from 'react'
import useSWR from 'swr';
import Skeleton from './Skeleton';
import { PAGE_KEY } from '../const';

import style from '../styles/goods.module.scss';

const Subgroups = () => {
  const { api } = useStores();
  const { slug, subgroupSlug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { data, isLoading } = useSWR(
    { slug, _key: `ng-subgroups-${slug}` },
    api.newCatalog.getNgSubgroupsBySlug
  );

  const handleClickSubgroup = (item) => {
    const preserved = new URLSearchParams(searchParams);
    preserved.delete(PAGE_KEY);
    const queryString = preserved.toString();
    const suffix = queryString ? `?${queryString}` : '';

    if (item.slug === null) {
      navigate(`/ng/${slug}/${suffix}`);
    } else {
      navigate(`/ng/${slug}/${item.slug}/${suffix}`);
    }
  };

  if (isLoading) {
    return <Skeleton />
  }

  return (
    <div className={style.subgroups}>{
      data?.map((item) => (
        <button
          key={item.id}
          onClick={() => handleClickSubgroup(item)}
          className={classNames(style.subgroups__item, {
            [style["subgroups__item--active"]]: item.slug === null
              ? !subgroupSlug
              : item.slug === subgroupSlug
          })}
        >
          <span className={style.subgroups__item_title}>
            {item.title}
          </span>
          <span className={style.subgroups__item_count}>
            ({item.products_count})
          </span>
        </button>
      ))
    }</div>
  )
}

export default Subgroups
